import CorsInfo from './CorsInfo';

export default CorsInfo;
